import * as Actions from '../actions';

const initialState = {
    studentProgressData: { loaded: false, choice: 'year', companyChoice: 'All', companyChoices: [] }
};

const progressReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_STUDENT_PROGRESS):
            {
                return {
                    ...state,
                    studentProgressData: { ...state.studentProgressData, ...action.payload }
                };
            };
        case (Actions.UPDATE_CHOICE):
            {
                return {
                    ...state,
                    studentProgressData: {
                        ...state.studentProgressData,
                        choice: action.payload
                    }
                }
            }
        case (Actions.RESET_STORE):
            {
                return {
                    ...initialState
                }
            }
        default:
            {
                return {
                    ...state
                }
            }
    };
};

export default progressReducer;


// WEBPACK FOOTER //
// src/main/content/progress/store/reducers/progress.reducer.js